import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { EmailMessage } from "../models/emails/email-message";
import { SearchDocuments } from "../models/search-documents";
import { SearcEmailsPagedResponse } from "../models/search-emails-paged-response";

@Injectable({
  providedIn: "root",
})
export class EmailService {
  baseUrl = "api/emails/";

  constructor(private http: HttpClient) {}

  getEmailMessages(deleted: boolean): Observable<EmailMessage[]> {
    return this.http.get<EmailMessage[]>(`${this.baseUrl}list/${deleted}`);
  }

  getEmailMessage(emailId: string) {
    return this.http.get<EmailMessage>(`${this.baseUrl}item/${emailId}`);
  }

  generateReport() {
    return this.http.get(`${this.baseUrl}export`, {
      responseType: "blob",
      observe: "response",
    });
  }

  save(emailMessage: EmailMessage): Observable<void> {
    return this.http.put<void>(
      `${this.baseUrl}save/${emailMessage?.id}`,
      emailMessage
    );
  }

  send(emailId: string) {
    return this.http.get(`${this.baseUrl}send/${emailId}`);
  }

  search(request: SearchDocuments) {
    return this.http.post<SearcEmailsPagedResponse>(
      `${this.baseUrl}search`,
      request
    );
  }

  updateTags(emailId: string, tagIds: string[]): Observable<void> {
    var req = {
      tagIds: tagIds,
    };
    return this.http.put<void>(`${this.baseUrl}${emailId}/tags`, req);
  }

  delete(id: string) {
    return this.http.delete(`${this.baseUrl}${id}`);
  }
}
